import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const logLiberacaoAutomaticaRepository = createRepository({
  path: 'log-liberacao-automatica',
  restApi,
  queryTransform: {
    cpf: query.likeDigits('cpf'),
    placa: query.likeAlphaDigits('placa'),
    ...paginate
  }
})

export default logLiberacaoAutomaticaRepository
